var exports = {
  "Qq": "ChannelReplyBar.module__text___QjczSz",
  "Y_": "ChannelReplyBar.module__replyTargetButton___QjczSz",
  "fh": "ChannelReplyBar.module__authorName___QjczSz",
  "ne": "ChannelReplyBar.module__controls___QjczSz",
  "xS": "ChannelReplyBar.module__mentionToggle___QjczSz",
  "If": "ChannelReplyBar.module__mentionToggleOn___QjczSz",
  "G9": "ChannelReplyBar.module__mentionToggleOff___QjczSz",
  "mM": "ChannelReplyBar.module__mentionIcon___QjczSz",
  "b": "ChannelReplyBar.module__closeButton___QjczSz",
  "ut": "ChannelReplyBar.module__closeIcon___QjczSz",
};

module.exports = exports;
